import { Component, OnInit } from '@angular/core';
import {  ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../services/authentincation.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    constructor(
        private authService: AuthenticationService,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
    }

    submit(form){
        const t = this;

        this.authService.contact(form).subscribe((data: any) => {

            t.toastr.success('Forumular trimis cu succes', 'Trimitere formular');
        }, () => {
            t.toastr.error('Formular netrimis', 'Trimitere formular');
        });

    }

}
